// Display name for an integration provider / broker. Known ones get proper
// casing; anything new falls back to a Capitalised slug so the UI never shows a
// raw key. Shared across admin surfaces (the integration catalog + the tool
// usage provider filter) so a provider is labelled identically everywhere.
const PROVIDER_LABEL: Record<string, string> = {
  composio: "Composio",
  servicem8: "ServiceM8",
  simpro: "Simpro",
  native: "Native",
  arcade: "Arcade",
};

export const providerLabel = (provider: string): string =>
  PROVIDER_LABEL[provider] ?? provider.charAt(0).toUpperCase() + provider.slice(1);
